import React, {useState} from 'react'
import {graphql} from 'gatsby'
import {Collapse} from 'react-collapse'
import Button from '../Button/Button'
import './PriceTable.scss'

const Discount = ({content, image, button}) => {
	return(
		<div className="PriceTable-Discount">
			<div className="content">
				<div className="text" dangerouslySetInnerHTML={{__html: content}} />
				{
					button &&
					<Button {...button} color="primary-white" />
				}
			</div>
			{
				image &&
				<div className="bg" style={{backgroundImage: `url(${image.localFile.childImageSharp.fluid.src})`}}></div>
			}
		</div>
	)
}

const Row = ({row, discount}) => {
	let className = 'price';
	let colspan = '1';
	if(discount.active) { className = 'old-price' }
	if(!row.priceNumber && discount.active) { colspan = '2'; className = 'price span'; }
	return (
		<tr>
			<th>{row.users}</th>
			<td colSpan={colspan} className={className}>
				{
					discount.active && row.priceNumber &&
					<span className="screen-reader-only">Pris: </span>
				}
				<span className="price-inner">{row.priceNumber ? `kr ${row.priceNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}` : <span dangerouslySetInnerHTML={{__html: row.price}} /> }</span>
			</td>
			{	discount.active && row.priceNumber &&
				<td className="new-price">
					<span className="screen-reader-only">Avslagspris: </span>
					{`kr ${(row.priceNumber * discount.amount / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") }`}
				</td>
			}
		</tr>
	)
}

export default function PriceTable({maxRows, table, id, discount, textBefore, tableHeaderTitle}) {

	const [showTable, setShowTable] = useState(false)

	return(
		<div className="PriceTable" aria-live="polite">
			{
				discount.active &&
				<Discount {...discount} />
			}
			<table>
				<thead>
					<tr>
						<th>{tableHeaderTitle || 'Antall brukere'}</th>
						<th colSpan="2">Pris per år</th>
					</tr>
				</thead>
				<tbody>
					{
						table.map((row, i) => {
							if((i+1) <= maxRows) {
								return(
									<Row key={`${id}_${i}`} row={row} discount={discount} />
								)
							}
							return null
						})
					}
				</tbody>
			</table>
			{
				table.length > maxRows &&
				<Collapse isOpened={showTable}>
					{
						showTable &&
						<table className="hidden" aria-hidden={!showTable}>
							<tbody>
								{
									table.map((row, i) => {
										if((i+1) > maxRows) {
											return(
												<Row key={`${id}_${i}`} row={row} discount={discount} />
											)
										}
										return null
									})
								}
							</tbody>
						</table>
					}
				</Collapse>
			}
			{
				table.length > maxRows &&
				<button aria-label={showTable ? 'Minimer tabell over' : 'Ekspander tabell over'} className={`expandButton ${showTable ? 'active' : ''}`} aria-expanded={showTable} onClick={() => setShowTable(!showTable) }>
					<span>
						{showTable ? 'Vis mindre' : 'Vis mer'}
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.51 17.774">
							<g transform="translate(28.389 -12) rotate(90)">
								<path d="M35.712,20.634,29.879,14.8,31.8,12.879l7.755,7.755L31.8,28.389l-1.922-1.922Z" transform="translate(-9.781)" />
								<path d="M12,27H26.947v2.718H12Z" transform="translate(0 -7.725)" />
							</g>
						</svg>
					</span>
				</button>
			}
			{
				textBefore &&
				<p className="textBefore" dangerouslySetInnerHTML={{__html: textBefore}} />
			}
		</div>
	)
}

export const query = graphql`
	fragment PriceTable on WpPage_Layout_block_Layout_PriceTable {
		fieldGroupName
		maxRows
		textBefore
		tableHeaderTitle
		discount {
			active
			amount
			content
			button {
				url
				title
				target
			}
			image {
				localFile {
					childImageSharp {
						fluid(maxWidth: 1000) {
							...GatsbyImageSharpFluid
						}
					}
				}
			}
		}
		table {
			price
			priceNumber
			users
		}
	}
`